export default {
    setRouterName: ({commit}, param) => commit('SET_ROUTER_NAME', param),
    setLoginStatus: ({commit}, param) => commit('SET_LOGIN_STATUS', param),
    setUserInfo: ({commit}, param) => commit('SET_USER_INFO', param),
    setBreadcrumbList: ({commit}, param) => commit('SET_BREADCRUMB_LIST', param),
    setInnerHeight: ({commit}, param) => commit('SET_INNER_HEIGHT', param),
    setFullStatus: ({commit}, param) => commit('SET_FULL_STATUS', param),
}




// WEBPACK FOOTER //
// ./src/store/navigation/action.js